import Axios from 'axios';
import { Select as ChakraReactSelect } from 'chakra-react-select';
import usePlacesAutocomplete, { getGeocode, getLatLng } from 'use-places-autocomplete';

export type Location = {
  recipient: string;
  latitude: number;
  longitude: number;
  name: string;
  lineOne: string;
  city: string;
  state: string;
  country: string;
  zipCode: string;
  timeZone: string;
};

type Props = {
  onSelect?: (location: Location) => void;
};

export const LocationAutocomplete = ({ onSelect }: Props) => {
  const {
    value,
    setValue: setLocationValue,
    suggestions,
  } = usePlacesAutocomplete({
    debounce: 300,
    defaultValue: '',
  });

  const handleLocationSelect = async (item: any) => {
    try {
      setLocationValue(item?.label);

      const results = await getGeocode({ address: item?.label });
      const result = results?.[0];
      const coords = getLatLng(result);

      const timeZoneRes = await Axios.get(
        `https://maps.googleapis.com/maps/api/timezone/json?location=${coords?.lat},${coords?.lng}&timestamp=1331161200&key=AIzaSyD7QIPpD3anAtZiuY-JTSEmRilJcXiBtlc`,
      );

      const name = result?.address_components?.find((n) => n?.types?.includes('airport'))?.long_name;
      const city = result?.address_components?.find((n) => n?.types?.includes('locality'))?.long_name;

      const state = result?.address_components?.find((n) =>
        n?.types?.includes('administrative_area_level_1'),
      )?.long_name;

      const zipCode = result?.address_components?.find((n) => n?.types?.includes('postal_code'))?.long_name;
      const country = result?.address_components?.find((n) => n?.types?.includes('country'))?.long_name;

      onSelect?.({
        latitude: coords?.lat,
        longitude: coords?.lng,
        name,
        recipient: name || '',
        lineOne: result.formatted_address,
        city,
        state,
        country,
        zipCode,
        timeZone: timeZoneRes?.data?.timeZoneId,
      });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <ChakraReactSelect
      isSearchable
      isClearable
      menuPlacement="bottom"
      selectedOptionColorScheme="orange"
      variant="filled"
      chakraStyles={{
        dropdownIndicator: (provided) => ({
          ...provided,
          display: 'none',
        }),
      }}
      placeholder="Autocomplete for address below..."
      size="md"
      value={value}
      onInputChange={(e: any) => {
        setLocationValue?.(e);
      }}
      onChange={handleLocationSelect}
      options={
        suggestions?.data?.map((option) => ({
          label: option?.description,
          value: option?.place_id,
        })) as any[]
      }
    />
  );
};
